module.exports = __webpack_public_path__ + "img/bacteria2.44c95d8d.png";